<div #calendar>
  <ng-content></ng-content>
</div>

